<template>
  <div id="app">
    <div class="header">
      <div class="logo_img" @click="logoClick">
        <div style="display:flex; align-items: center; float:left; height: 65px;">
          <div class="header-logo">
            <img id="header-img" src="../assets/logo.png">
          </div>
        </div>
        <div style="display:flex; float:left; height: 65px;">
          <div class="header-important">
            <div class="company_name">广州锐动网络科技有限公司</div>
            <div class="header-title company_name">{{ host }}</div>
          </div>
        </div>
      </div>
      <div id="menu_index">
        <!-- web端菜单导航 -->
        <el-menu v-if="seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333"
                 style="height: 65px; border:0;" mode="horizontal" @select="handleSelect">
          <el-menu-item index="1" class="header-title">首页</el-menu-item>
          <el-submenu index="2">
            <template slot="title">开发服务</template>
            <el-menu-item index="2-1">功能界面</el-menu-item>
            <el-menu-item index="2-2">门店外卖</el-menu-item>
          </el-submenu>
          <el-menu-item index="3" class="header-title">服务内容</el-menu-item>
          <el-menu-item index="5" class="header-title">关于我们</el-menu-item>
        </el-menu>
        <!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
        <el-menu v-if="!seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333"
                 style="height: 65px; border:0;" mode="horizontal" @select="handleSelectMobile">
          <el-submenu index="1" class="header-title mobile_menu">
            <template slot="title">{{ currentMenu }}</template>
            <el-menu-item index="1" class="header-title">首页</el-menu-item>
            <el-menu-item index="2-2" class="header-title">门店外卖</el-menu-item>
            <el-menu-item index="2-1" class="header-title">功能界面</el-menu-item>
            <el-menu-item index="3" class="header-title">服务内容</el-menu-item>
            <el-menu-item index="5" class="header-title">关于我们</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div v-if="seen" style="float: right; display: none;align-items: center; height: 100%;">
        <el-button type="text" style="margin-right: 20px;" class="header-title" @click="login">登录</el-button>
        <el-button type="primary" class="header-title" @click="register" round>注册</el-button>
      </div>
    </div>
    <div class="container" style="clear: both;">
      <router-view></router-view>
    </div>

    <div style="width: 90%;margin: 20px auto;">
      <div style="height:1px;padding:0;background-color:#999;">
      </div>
    </div>
    <div style="width: 90%;margin: 20px auto;">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12">
          <div class="footer_font">邮箱：2996762481@qq.com</div>
          <div class="footer_font">地址：广州市天河区黄村三联路12号B2栋一楼B1097（仅限办公）</div>
          <div class="footer_font"><a href="https://beian.miit.gov.cn/" target="_blank">{{ beian }}</a></div>
          <div class="footer_font"> ©版权所有广州锐动网络科技有限公司</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Layout",
  data() {
    return {
      activeIndex: '1',
      seen: true,
      currentMenu: '首页',
      host: "",
      beian: ""
    };
  },
  created() {
    this.host = location.host
    axios.get('/beian/beian.json')
        .then((response) => {
          this.beian = response.data[location.host]
        })
        .catch(function (error) {
          // eslint-disable-next-line no-console
          console.log(error)
        })
  },
  methods: {
    handleSelect(key) {
      switch (key) {
        case '1':
          this.$router.push({ name: "Index" });
          break;
        case '2-1':
          window.location.hash = "#功能界面";
          break;
        case '2-2':
          this.$router.push({ name: "Fruit" });
          break;
        case '3':
          this.$router.push({ name: "Index" });
          window.location.hash = "#服务内容";
          break;
        case '5':
          this.$router.push({ name: "Index" });
          window.location.hash = "#关于我们";
          break;
      }
    },
    handleSelectMobile(key) {
      switch (key) {
        case '1':
          this.$router.push({ name: "Index" });
          this.currentMenu = '首页';
          break;
        case '2-1':
          this.$router.push({ name: "Index" });
          window.location.hash = "#功能界面";
          this.currentMenu = '首页';
          break;
        case '2-2':
          this.$router.push({ name: "Fruit" });
          this.currentMenu = '门店外卖';
          break;
        case '3':
          this.$router.push({ name: "Index" });
          window.location.hash = "#服务内容";
          this.currentMenu = '首页';
          break;
        case '5':
          this.$router.push({ name: "Index" });
          window.location.hash = "#关于我们";
          this.currentMenu = '首页';
          break;
      }
    },
    login() {
      window.open('https://admin.fastice-tech.com/login')
    },
    register() {
      window.open('https://admin.fastice-tech.com/registe')
    },
    menuSeen() {
      // 屏幕尺寸
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        this.seen = true;
      } else {
        this.seen = false;
      }
    },
    logoClick() {
      this.$router.push({ name: "Index" });
      this.currentMenu = '首页';
    }
  },
  mounted() {
    this.menuSeen()
  },
}
</script>

<style scoped>
.logo_img {
  float: left;
  width: 30%;
  cursor: pointer;
}

.header-title {
  font-size: 1em;
}

.company_name {
  font-weight: normal;
  font-size: 1em;
}

.footer_font {
  font-size: 1em;
  margin-bottom: 10px;
}

.footer_font a {
  text-decoration: none;
}

#menu_index {
  float: left;
  width: 50%;
  height: 100%
}

.header {
  margin: auto;
  width: 90%;
  height: 65px;
  /*background: #F56C6C;*/
}

@media screen and (max-device-width: 415px) {
  .logo_img {
    float: left;
    width: auto;
    cursor: pointer;
  }

  .footer_font {
    font-size: 0.875em;
  }

  #menu_index {
    float: right;
    width: auto;
    height: 100%
  }

  .mobile_menu {

  }
}

#header-img {
  height: 50px;
  float: left;
  margin: auto;
}

.header-logo {
  height: 50px;
  align-self: center;
}

.header-important {
  float: left;
  margin-left: 6px;
  align-self: center;
}

.footer {
  display: flex;
  align-items: center;
  margin: 10px auto;
  width: 90%;
}

a {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}
</style>
